import { defineComponent } from 'vue';
import { QIcon, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

export default defineComponent({
    name: 'control-group-document-preview',
    components: {
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
            control: {},
        }
    },
    props: {
        documentName: '',
        moduleName: '',
        root: null,
        parentNode: null,
        showOpen: false,
    },
    computed: {
        Root: function () {
            return this.root;
        },
    },
    created() {
        this.watcher$ = this.$watch('documentName', function () {
            this.Refresh();
        });
    },
    unmounted() {
        this.watcher$();
    },
    async mounted() {
        await this.Refresh();
    },
    methods: {
        ...methods,
        async Refresh() {
            if (this.documentName) {
                try {
                    let c = await utils.api.get('Apps/UI/UserControl/' + this.documentName);
                    if (!c)
                        c = await utils.api.get('Apps/UI/UserControl/public/' + this.documentName);

                    this.control = c;
                }
                catch (e) {
                    this.control = {};
                }
            }
            else
                this.control = {};
        },
        SelectNode(node) {
            if (this.parentNode)
                this.Root.SelectNode(this.parentNode);
        },
        handleClick(e) {
            if (this.parentNode)
                this.Root.SelectNode(this.parentNode);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        open(e) {
            this.Root.ExternalNavigateToName('UserControl', this.documentName);

            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    render() {
        const containerStyle = {
            position: 'relative',
            minHeight: '40px',
            minWidth: '80px',
            border: '1px solid silver',
            borderRadius: '8px',
            padding: '2px',
            margin: '1px',
        };

        const moduleIndicator = (
            <QIcon name="mdi-view-module" size="sm" style={{ position: 'absolute', top: '4px', right: '4px', zIndex: 35 }}>
                <QTooltip transitionHide="scale" transitionShow="scale">
                    <span style="font-size: larger;">From module: {this.moduleName}</span>
                </QTooltip>
            </QIcon>
        );

        const openTitle = 'Open ' + this.documentName;

        if (!this.control.ControlData)
            return (
                <div
                    class={{ 'designer-container': true }}
                    style={containerStyle}
                    onClick={(e) => this.handleClick(e)}>
                    <div
                        class="design-options designer-container-selected-clickableitem"
                        title={openTitle}
                        onClick={(e) => this.open(e)}
                        style={{ top: '4px', left: '4px', display: this.showOpen ? 'block' : 'none' }}>
                        Open
                    </div>
                    {moduleIndicator}
                    <div class={{ 'designer-user-control-hovering': true }}></div>
                    {this.documentName}
                </div>
            );

        let DynamicControl = utils.getDesignerComponent(this.control);

        return (
            <div
                class={{ 'designer-container': true }}
                style={containerStyle}
                onClick={(e) => this.handleClick(e)}>
                <div
                    class="design-options designer-container-selected-clickableitem"
                    title={openTitle}
                    onClick={(e) => this.open(e)}
                    style={{ top: '4px', left: '4px', display: this.showOpen ? 'block' : 'none' }}>
                    Open
                </div>
                {moduleIndicator}
                <div class={{ 'designer-user-control-hovering': true }}></div>
                <DynamicControl type={this.control.ControlType} name={this.control.ControlData.Name} root={this} controlData={this.control.ControlData}>
                </DynamicControl>
            </div>
        );
    }
});
